import Tag from 'models/tag/Tag';

/**
 * Class representing a achievement tag.
 * @extends Tag
 */
export default class AchievementTag extends Tag {}
